  document.addEventListener('DOMContentLoaded', function() {
    var accordions = document.querySelectorAll('.accordion');
    
    accordions.forEach(function(accordion) {
      accordion.addEventListener('click', function() {
        // Toggle the active state on the clicked button (question)
        this.classList.toggle('active');
        
        // Find the corresponding answer section (the next sibling of the button)
        var answerContainer = this.nextElementSibling;
        
        // Toggle the visibility of the answer content
        if (answerContainer.style.maxHeight){
          answerContainer.style.maxHeight = null;  // Hide the answer
        } else {
          answerContainer.style.maxHeight = answerContainer.scrollHeight + "px";  // Show the answer
        }

        // Rotate the arrow icon when the accordion is expanded or collapsed
        var arrow = this.querySelector('.accordion-arrow');
        if (this.classList.contains('active')) {
          arrow.style.transform = 'rotate(180deg)';  // Rotate the arrow when expanded
        } else {
          arrow.style.transform = 'rotate(0deg)';  // Reset the arrow when collapsed
        }
      });
    });
  });